export default class LongPressEventData {

	constructor(params) {
		if (params === undefined)
			params = {};

		this.mouse_pointer = {
			x: 0,
			y: 0,
		};
		this.handler = null;
		this.timer = null;
		this.threshold = 2;
	}

	validate_mouse_pointer(point) {
		let diff_x = Math.abs(this.mouse_pointer.x - point.x);
		let diff_y = Math.abs(this.mouse_pointer.y - point.y);
		return (diff_x < this.threshold) && (diff_y < this.threshold);
	}

	refresh_mouse_pointer_from_event(e) {
		this.refresh_mouse_pointer(this.create_mouse_point(e));
	}

	refresh_mouse_pointer(point) {
		if(point === undefined)
			return;
		
		this.mouse_pointer.x = point.x;
		this.mouse_pointer.y = point.y;
	}

	create_mouse_point(obj) {
		if(obj.pageX === undefined)
			return;
		
		return { x: obj.pageX, y: obj.pageY };
	}
}
